import styled, { css } from 'foundations-theming-specialty/utils';
import TrackedButton from '../../../components/TrackedButton';
import withTransientStyleProps from '../../../utils/withTransientStyleProps';
export const StyledHelpButton = styled(withTransientStyleProps(TrackedButton))(({
  theme
}) => {
  return css(["background:transparent;padding:8px !important;border-style:none;border-radius:6px;height:100%;display:inline-flex;align-items:center;justify-content:center;position:relative;&:hover{background:", ";svg{fill:", ";}}"], theme.color['global-shell-fill-nav-item-hover'], theme.color['global-shell-icon-nav-item-hover']);
});
export const NotificationsIndicator = styled.div.withConfig({
  displayName: "HelpButton__NotificationsIndicator",
  componentId: "c6ipto-0"
})(({
  theme
}) => {
  return css(["position:absolute;width:14px;height:14px;top:2px;left:16px;border-radius:14px;background-color:", " !important;padding:1px 4px 2px 4px;::after{content:'\\2022';position:absolute;top:50%;left:50%;color:", ";font-size:11px;font-weight:400;transform:translate(-50%,-50%);}"], theme.color['fill-alert-default'], theme.color['text-alert-on-fill-default']);
});